module.exports = __webpack_public_path__ + "18544fe6d39d055cab4bf8f7aaa108e0.png";